import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: '[xpCard]',
	standalone: true,
	template: '<ng-content></ng-content>',
	styleUrls: ['./xp-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpCardComponent { }
